<template>
  <section>
    <div class="row">
      <div id="loadingmessage"
        style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
        v-if="loading">
        <p style="position: absolute; color: White; top: 40%; left: 50%;">
          <img src="../../assets/loader.gif" />
        </p>
      </div>
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Sightings Details</h4>
            <form class="form-sample" @submit="onSubmit">
              <div class="row">
                <div class="col-md-3 form-group" style="font-size:16px!important">
                  <label for="exampleInputEmail1">Please upload Image</label>
                  <br />

                  <input type="file" class="images" accept="image/*" id="file" ref="file"
                    v-on:change="handleFileUpload()" />
                  <p v-if="image">{{ data.photo }}</p>
                </div>
                <div class="col-md-2">
                  <div width="80px" height="80px" id="preview">
                    <img width="100%" height="100%" :src="image" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6" style="padding-bottom:20px!important">
                  <label horizontal>Turtle</label>
                  <b-form-select class="dropdown" name="donate now" v-model="turtle" required>
                    <option v-for="itm in turt" :key="itm._id" v-bind:value="itm._id">{{ itm.name }}</option>
                  </b-form-select>
                </div>

                <div class="col-md-6" style="padding-bottom:20px!important">
                  <label>Please Select Purpose of Reporting</label>
                  <select id="type" class="form-control" name="Chooae Type" required placeholder="Choose Type"
                    v-model="purpose">
                    <option></option>
                    <option value="observation">Observation</option>
                    <option value="rescue">Rescue</option>
                  </select>
                </div>

                <div v-if="purpose == 'observation'" class="col-md-6" style="padding-bottom:20px!important">
                  <label>Please Select a Condition</label>
                  <select id="type" class="form-control" name="Chooae Type" required placeholder="Choose Type"
                    v-model="condition">
                    <option></option>
                    <option value="live">live</option>
                    <option value="dead">dead</option>
                  </select>
                </div>

                <div v-if="condition && purpose == 'observation'" class="col-md-6"
                  style="padding-bottom:20px!important">
                  <label>Please Select a Type</label>
                  <select id="type" class="form-control" name="Chooae Type" required placeholder="Choose Type"
                    v-model="type">
                    <option></option>
                    <option value="wild">Wild</option>
                    <option value="zoo">Zoo</option>
                    <option value="commercialmarket">Commercial Market</option>
                    <option value="personalholding">Personal Holding</option>
                    <option value="religiousshrines/communityponds">Religious Shrines/Community Ponds</option>
                  </select>
                </div>
                <div v-if="type && purpose == 'observation'" class="col-md-6" style="padding-bottom:20px!important">
                  <label>Please Select a Life Stage</label>
                  <select id="type" class="form-control" name="Chooae Type" required placeholder="Choose Type"
                    v-model="lifestage">
                    <option></option>
                    <option value="adult">Adult</option>
                    <option value="hatchling">Hatchling</option>
                    <option value="nestoreggs">Nest or Eggs</option>
                  </select>
                </div>
                <div v-if="purpose == 'rescue'" class="col-md-6" style="padding-bottom:20px!important">
                  <label>Please Select a Situation</label>
                  <select id="situation" class="form-control" name="Chooae Type" required placeholder="Choose Type"
                    v-model="situation">
                    <option></option>
                    <option value="illegaltrade">Illegal Trade</option>
                    <option value="commercialmarket">Commercial Market</option>
                    <option value="personalholding">Personal Holding</option>
                    <option value="others">Others</option>
                  </select>
                </div>

                <div class="col-md-6">
                  <b-form-group label="State">
                    <b-form-input required type="text" v-model="state"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Nearest City">
                    <b-form-input required type="text" v-model="nearestcity"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Comments">
                    <b-form-input required type="text" v-model="comment"></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <label for="exampleInputEmail1" style="font-size:20px!important">Please Edit Location</label>

              <div class="input-group-prepend">
                <br />
                <div class="col-md-6">
                  <input name="lat" type="text" v-model="lat" class="form-control" placeholder="Please Enter Latitude"
                    required />
                </div>
                <br />
                <div class="col-md-6">
                  <input name="lon" type="text" v-model="lon" ref="myLngField" placeholder="Please Enter Longitude"
                    class="form-control" required />
                </div>
              </div>

              <br />

              <div id="myMap"></div>
              <br />
              <b-button variant="primary" class="btn-fw" type="submit">Submit</b-button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>



<script>
import axios from "axios";
export default {
  name: "edituser",
  props: ["id"],
  data: () => {
    return {
      purpose: "",
      lifestage: "",
      condition: "",
      uname: "",
      nearestcity: "",
      state: "",
      type: "",
      image: null,
      turtle: "",
      comment: "",
      loading: false,
      data: [],
      lat: null,
      lon: null,
      situation: "",
      turt: [],
      file: null,
      msg: "",
      createDate: null,
    };
  },
  mounted: function () {
    this.getview();
    this.getTurtleList();
    this.getListClick();
  },
  watch: {
    lat: function () {
      this.getListClick();
    },
    lon: function () {
      this.getListClick();
    },
  },
  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.image = URL.createObjectURL(this.file);
    },
    getTurtleList() {
      this.loading = true;
      axios({
        method: "GET",
        url: "/turtle/getlist",
      })
        .then((response) => {
          this.loading = false;
          var temp = [];
          if (response.data.status === true) {
            // for (var j = 0; j < response.data.data.length; j++) {
            //   var ty = response.data.data[j].name;
            //   temp.push(ty);
            // }
            // this.turt = temp;
            this.turt = response.data.data;
            this.loading = false;
          } else if (response.data.status === false) {
            this.loading = false;
          }
        })
        .catch((e) => {
          this.loading = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },

    getview() {
      this.visible = true;
      axios({
        method: "GET",
        url: "/report/get",
        params: { id: this.id },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.lat = response.data.data.location[1];
            this.lon = response.data.data.location[0];
            this.purpose = response.data.data.purpose;
            this.condition = response.data.data.condition;
            this.situation = response.data.data.situation;
            this.lifestage = response.data.data.lifestage;
            this.nearestcity = response.data.data.nearestcity;
            this.state = response.data.data.state;
            this.type = response.data.data.type;
            this.comment = response.data.data.comment;
            this.turtle = response.data.data.turtle._id;
            this.uname = response.data.data.userid.name;
            this.createDate = response.data.data.turtle.createddate.slice(
              0,
              10
            );
            // this.id = response.data.data._id;

            if (response.data.data.image != null) {
              this.image = imageURL + response.data.data.image;
            }

            this.visible = false;
          } else if (response.data.status === false) {
            this.visible = false;
          }
        })
        .catch((err) => {
          this.errors.push(err);
          alert("No Network Found!!");
        });
    },

    getListClick() {
      var marker = 1;
      var vm = this;
      var centerOfMap = new google.maps.LatLng(10.030551, 76.524354);
      var options = {
        zoom: 4,
        center: centerOfMap,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false
      };
      var map = new google.maps.Map(document.getElementById("myMap"), options);
      var latlngset = new google.maps.LatLng(this.lat, this.lon);

      marker = new google.maps.Marker({
        map: map,
        position: latlngset
      });

      marker.setPosition(latlngset);

      google.maps.event.addListener(map, "click", function (event) {
        this.click = true;
        var clickedLocation = event.latLng;

        if (marker == 1) {
          marker = new google.maps.Marker({
            position: clickedLocation,
            map: map,
            draggable: true
          });
          google.maps.event.addListener(marker, "dragend", function (event) {
            vm.markerLocation(marker);
          });
        } else {
          marker.setPosition(clickedLocation);
        }

        //Get the marker's location.
        vm.markerLocation(marker);
      });
    },
    markerLocation(marker) {
      var currentLocation = marker.getPosition();
      this.lat = currentLocation.lat(); //latitude
      this.lon = currentLocation.lng(); //longitude
    },
    onSubmit(evt) {
      evt.preventDefault();
      var add = {};

      add["turtle"] = this.turtle;
      add["purpose"] = this.purpose;
      add["condition"] = this.condition;
      add["situation"] = this.situation;
      add["type"] = this.type;
      add["lifestage"] = this.lifestage;
      add["nearestcity"] = this.nearestcity;
      add["lat"] = this.lat;
      add["lon"] = this.lon;
      add["state"] = this.state;
      add["x-auth-token"] = localStorage.getItem("token");
      add["id"] = this.id;
      add["comment"] = this.comment;

      axios({
        method: "post",
        url: "/report/edit",
        data: add,
      })
        .then((response) => {
          this.msg = response.data.msg;

          this.loading = "false";
          if (response.data.status === true) {
            this.loading = false;

            let formData = new FormData();
            formData.append("token", localStorage.getItem("token"));
            formData.append("id", this.id);
            formData.append("image", this.file);

            axios({
              method: "post",
              url: "/report/imageupload",
              data: formData,
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
              .then((response) => {
                if (response.data.status === true) {
                  alert("Updated Successfully");
                  this.$router.push({ path: "/reportlist" });
                } else this.msg = response.data.msg;
                alert("Updated Successfully");
                this.$router.push({ path: "/reportlist" });
              })
              .catch((e) => {
                this.loading = false;
                this.error = e.response.data.msg;
                alert("Updated Successfully");
                this.$router.push({ path: "/reportlist" });
              });
          }
          if (response.data.status === false) {
            this.loading = false;

            alert("Please try again");
          }
        })
        .catch((err) => {
          this.loading = false;

          alert("Please try again");
        });
    },
  },
};
</script>

<style>
#myMap {
  height: 400px !important;
  width: 100%;
}
</style>